export default __webpack_public_path__ + "static/media/jahangeer_1.94e898ec.jpg";